import { Component, Input } from '@angular/core';

/**
   * Logger Factory
   * @namespace title: title of link
   * <ute-link title="rinnova"></ute-link>

*/

@Component({
  selector: 'ute-link',
  templateUrl: 'ute-link.component.html'
})
export class UteLinkComponent {
  @Input() title: any;
  @Input() link: any;

  constructor() {}
}


// WEBPACK FOOTER //
// ./src/app/components/commons/atoms/ute-link/ute-link.component.ts